<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/2 w-full mb-4">
      <vs-radio
        @input="$gtag.event('Audience_New')"
        id="create-campaign-s3-add-audience-checbox"
        v-model="value.new_audience"
        :vs-name="`step3.adsets.${adsetIndex}.new_audience`"
        :vs-value="true"
      >
        {{ $t("Add new audience") }}
      </vs-radio>
    </div>

    <div class="vx-col md:w-1/2 w-full mb-4">
      <vs-radio
        @input="$gtag.event('Audience_Saved')"
        id="create-campaign-s3-choose-saved-audience-checkbox"
        v-model="value.new_audience"
        :vs-name="`step3.adsets.${adsetIndex}.new_audience`"
        :vs-value="false"
      >
        {{ $t("Choose from saved audience") }}
      </vs-radio>
    </div>


    <div class="vx-col md:w-1/2 w-full mb-6" v-if="value.new_audience">
      <vs-input id="create-campaign-s3-audience-input" :label="$t('Audience Name')" v-model="value.new_audience_name" :name="`step3.adsets.${adsetIndex}.new_audience_name`" v-validate="'required|max:25'" :data-vv-as="$t('Audience Name')" :danger="$vErrors.has([errors, serverErrors], `step3.adsets.${adsetIndex}.new_audience_name`)"  :placeholder="$t('Audience Name')" class="w-full" maxLength="25" />
      <span v-if="$vErrors.has([errors, serverErrors], `step3.adsets.${adsetIndex}.new_audience_name`)" class="text-danger">
        {{ $vErrors.first([errors, serverErrors], `step3.adsets.${adsetIndex}.new_audience_name`) }}
      </span>
    </div>
    <div class="vx-col md:w-1/2 w-full mb-6" v-else>
      <label class="input-label">{{ $t('Audience Name') }}</label>
      <v-select
        @input="$gtag.event('Audience_Savedchoose')"
        :name="`step3.adsets.${adsetIndex}.audience_id`"
        v-model="value.audience_id"
        label="name"
        :reduce="o => o.id"
        :options="audiences"
        class="baisc-select mt-3"
        :placeholder="$t('Not Selected')"
        :dir="$vs.rtl ? 'rtl' : 'ltr'"
      />

      <span v-if="$vErrors.has([errors, serverErrors], `step3.adsets.${adsetIndex}.audience_id`)" class="text-danger">
        {{ $vErrors.first([errors, serverErrors], `step3.adsets.${adsetIndex}.audience_id`) }}
      </span>
    </div>
  </div>
</template>


<script>

import _ from 'lodash'

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    adsetIndex: {
      type: Number,
      required: true
    },
    serverErrors: {
      required: true
    }
  },
  computed: {
    audiences () {
      const audiences = _.cloneDeep(this.$store.getters['campaign/targetingLookups'].audiences)

      return audiences.map((audience) => {
        audience.target = this.standardizeTarget(audience.target)

        return audience
      })
    }
  },
  watch: {
    value: {
      handler (newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    },
    'value.audience_id' () {
      this.audienceSelected()
    }
  },
  created () {
    this.$root.$on('audience:created', (audience) => {
      const exists = this.audiences.findIndex(i => i.id === audience.id) > -1
      if (!exists) {
        this.audiences.push(audience)
      }
    })
  },
  methods: {
    audienceSelected () {
      this.$emit('audience:selected', this.audiences.find(i => i.id === this.value.audience_id))
    },

    standardizeTarget (target) {
      const shouldHaveKeys = {
        'locations': {
          countries:[],
          cities:[]
        },
        'isps':[],
        'target_devices':[],
        'target_platforms':{
          'websites':[],
          'apps':[],
          'purgeable_disallowed_domains_history':[],
          'include_new_platforms':true
        },
        'content_categories':[],
        'frequency_capping':0
      }
      return _.assign(shouldHaveKeys, target)
    }

  }
}
</script>
